import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorBoundary } from 'wsm-error-boundary';
import loadShift from '../utils/loadShift';

import DataMapper from '../components/DataMapper';
import LegacyTracking from '../components/LegacyTracking';

let timeout;

const hasNativeProject = (mapping) =>
	typeof Object.values(mapping).find(
		(val) => typeof val.legacy === 'undefined'
	) !== 'undefined';
export class WidgetContainer extends React.Component {
	componentDidMount() {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tagging'] =
			window.DDC.WidgetData['ws-tagging'] || {};
		window.DDC.WidgetData['ws-tagging'].mapping = this.props.mapping;
		window.dispatchEvent(new Event('ws-tagging-ready'));
	}

	componentWillUnmount() {
		clearTimeout(timeout); // added to pass a unit test but also makes sure setState doesn't run when component unmounted
		delete window.DataLayerHelper;
	}

	render() {
		let component;
		if (typeof window !== 'undefined' && window?.DDC?.isComposer) {
			component = null;
		} else {
			loadShift(this.props.legacyConfigurations);

			component = (
				<ErrorBoundary newRelicPageAction="ws-tagging error boundary">
					<div data-testid="Widget">
						{hasNativeProject(this.props.mapping) && (
							<DataMapper mapping={this.props.mapping} />
						)}
						{this.props.legacyConfigurations?.length > 0 && (
							<LegacyTracking
								legacyConfigurations={
									this.props.legacyConfigurations
								}
							/>
						)}
					</div>
				</ErrorBoundary>
			);
		}
		return component;
	}
}

WidgetContainer.propTypes = {
	legacyConfigurations: PropTypes.arrayOf(PropTypes.object),
	mapping: PropTypes.objectOf(PropTypes.object)
};

const mapStateToProps = (state) => {
	return {
		mapping: state.mapping,
		legacyConfigurations: state.legacyConfigurations,
		flags: state.flags
	};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
